// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"90840b8aaf8323eea361","454":"2fdabc7318c8319e99af"}[chunkId] + ".js";
};